import { requestTool } from "../tools";

const CONTROLLER_URL = "/api/feedBack/GetUseFeedBack";


const getUseFeedBack = () => requestTool.
    getRequest(process.env.REACT_APP_CRUD_API_URL + CONTROLLER_URL);


export const feedBackService = {

    getUseFeedBack
};

export default feedBackService;